export default function CustomLegend(props) {
  const { payload } = props

  return (
    <ul
      className="recharts-default-legend"
      style={{ padding: "0px", margin: "0px", textAlign: "center" }}
    >
      {payload
        .sort((entry, index) => (entry.display ? -1 : 1))
        .map((entry, index) => (
          <li
            key={entry.dataKey}
            className={"recharts-legend-item legend-item-" + index}
            style={{
              display: "inline-block",
              marginRight: "10px",
              visibility: entry.display ? "visible" : "hidden",
            }}
            data-unique={entry.dataKey}
            onMouseEnter={props.onMouseEnter}
            onMouseLeave={props.onMouseLeave}
            onClick={props.onClick}
          >
            <svg
              className="recharts-surface"
              width="14"
              height="14"
              viewBox="0 0 32 32"
              style={{
                display: "inline-block",
                verticalAlign: "middle",
                marginRight: "4px",
              }}
            >
              <title>{entry.dataKey}</title>
              <desc></desc>
              <path
                strokeWidth="4"
                fill="none"
                stroke={entry.color}
                d="M0,16h10.666666666666666
          A5.333333333333333,5.333333333333333,0,1,1,21.333333333333332,16
          H32M21.333333333333332,16
          A5.333333333333333,5.333333333333333,0,1,1,10.666666666666666,16"
                className="recharts-legend-icon"
              ></path>
            </svg>
            <span
              className="recharts-legend-item-text"
              style={{ color: entry.color }}
            >
              {entry.dataKey}
            </span>
          </li>
        ))}
    </ul>
  )
}
